import { Heading } from '@makemydeal/dr-ui-bricks-components';
import type { PageHeadingProps } from '../../types';

/**
 * PageHeading
 *
 * Shared page/section title built on top of the `Heading` component from
 * `ui-bricks-components`. Standardizes the default level/weight used for
 * page titles across Sales Check-In so consuming components don't need to
 * repeat the same `Heading` props.
 */
export const PageHeading = ({ children, 'data-testid': dataTestId = 'page-heading' }: PageHeadingProps) => (
    <Heading level={2} weight="bold" data-testid={dataTestId}>
        {children}
    </Heading>
);

export default PageHeading;
